import React from "react";
import { Link } from "react-router-dom";
import placeholder from "../assets/Car place holder PNG.png"; // Make sure this path is correct

const BrandCard = ({ brand }) => {
  // Handle missing/empty image URLs
  const imageSrc = brand.imageUrl || placeholder;

  return (
    <Link to={`/search?makeId=${brand.id}`}>
      <div className='p-6 transition-shadow duration-200 text-center rounded-lg hover:scale-105'>
        <div className='mx-auto mb-4 flex items-center justify-center'>
          <img
            src={imageSrc}
            className='h-[123px] mx-auto cursor-pointer transition duration-200  '
            alt={brand.name}
            onError={(e) => {
              e.target.src = placeholder; // Fallback if image fails to load
            }}
          />
        </div>

        <p className='text-[16px] font-bold text-primary-dark'>
          <span className='font-semibold text-[#050B20] block'>
            {brand.name}
          </span>
          ({brand.vehicleCount})
        </p>
      </div>
    </Link>
  );
};

export default BrandCard;
